<div style="width: calc(720px + 1rem);"></div>
<h4>
  <span>
    {{ selectedLottery.event.date.date | date: 'dd.MM.yyyy' }}
    {{ selectedLottery.event.getFormattedEventName() }}
  </span>
</h4>
<div class="esf-info-tile esf-info-tile--static">
  <div class="esf-info-tile__content">
    <div class="esf-execution__info settings-margin">
      <div>
        <div class="esf-icon-and-text esf-icon-and-text--xs">
          <svg class="esf-icon esf-icon-and-text__icon esf-icon--info" width="16" height="16">
            <use xlink:href="#esf-icon-user-16"></use>
          </svg>
          <span class="esf-icon-and-text__text esf-icon--info">
            <span class="esf-icon--info">{{ executionSummary.numberOfRequests }}</span>
          </span>
        </div>
      </div>
      <div>
        <div class="esf-icon-and-text esf-icon-and-text--xs">
          <svg class="esf-icon esf-icon-and-text__icon" width="16" height="16">
            <use xlink:href="#esf-icon-ticket-16"></use>
          </svg>
          <span class="esf-icon-and-text__text">{{ executionSummary.numberOfRequestedTickets }}</span>
        </div>
      </div>
      <div class="esf-icon-and-text esf-icon-and-text--xs">
        <svg class="esf-icon esf-icon--success esf-icon-and-text__icon" width="16" height="16">
          <use xlink:href="#esf-icon-sofa-16"></use>
        </svg>
        <span class="esf-icon-and-text__text">
          <span class="esf-icon--success">{{ executionSummary.priceCategoryCapacity }}</span>
        </span>
      </div>
    </div>
  </div>
</div>

<form [formGroup]="lotteryExecutionForm" (ngSubmit)="showExecuteModal()" id="lotteryExecutionForm">
  <h4></h4>
  <label class="esf-form-item__label" for="text-field">
    <div class="esf-form-item__label-main" i18n="@@general.formLabel.howManyTicketsSeated">How many tickets do you want to be seated?</div>
    <div class="esf-form-item__label-sub" i18n="@@general.formSubLabel.howManyTicketsSeated">The system will try to reserve the requested amount of tickets in Tixx. It will stop the process after 10 consecutive failing requests.</div>
  </label>
  <div app-form-field-number
       [isCurrency]="false"
       [max]="limitCapacity"
       [control]="lotteryExecutionForm.controls['capacityLimit']">
  </div>

  <app-submit-row-buttons style="max-width: calc(720px + 2rem);"
                          [form]="'lotteryExecutionForm'"
                          [isFieldValid]="lotteryExecutionForm.valid"
                          [cancelButtonText]="buttonsTranslations.i18nBackToRequestFiltering"
                          [submitButtonText]="buttonsTranslations.i18nExecuteLotterySeating"
                          (cancelButton)="backStepEmitter.emit('click')">
  </app-submit-row-buttons>

</form>
